"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[826],{

/***/ 1826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yd": function() { return /* reexport */ Job_ApplyJob; },
  "dk": function() { return /* reexport */ Job_Description; },
  "VM": function() { return /* reexport */ Detail_Hero; },
  "ob": function() { return /* reexport */ career_Items; },
  "aV": function() { return /* reexport */ Detail_List; },
  "dE": function() { return /* reexport */ Job_SecondHero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./parts/career/Detail/Hero/index.js
/* eslint-disable */ 



function Hero(param) {
    var division = param.division, _dataHeader = param.dataHeader, dataHeader = _dataHeader === void 0 ? {} : _dataHeader, language = param.language, breadcrump = param.breadcrump;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var id = router.asPath.split("/");
    var ref2 = (0,react.useState)(""), breadcumbParentEn = ref2[0], setBreadcumbParentEn = ref2[1];
    var ref3 = (0,react.useState)(""), breadcumbParentId = ref3[0], setBreadcumbParentId = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        breadcrump === null || breadcrump === void 0 ? void 0 : (ref = breadcrump.HeaderMenus) === null || ref === void 0 ? void 0 : ref.forEach(function(item) {
            var ref;
            item === null || item === void 0 ? void 0 : (ref = item.child) === null || ref === void 0 ? void 0 : ref.forEach(function(secondItem) {
                // validate if parent 2 have url (page)
                if (((secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("id_url")) || (secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("en_url"))) && ("career" === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.id_url) || "career" === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.en_url))) {
                    setBreadcumbParentEn(item.en_menu_name);
                    setBreadcumbParentId(item.id_menu_name);
                }
            });
        });
    }, [
        dataHeader
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "top-page-detail pages-details-for-careers",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-in-area",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        className: "breadcrumb",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: "Home"
                                })
                            }),
                            language === "EN" && breadcumbParentEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: breadcumbParentEn
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            language === "ID" && breadcumbParentId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: breadcumbParentId
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/career",
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: language === "EN" ? dataHeader.en_title : dataHeader.id_title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: division === null || division === void 0 ? void 0 : (ref = division.divisionData) === null || ref === void 0 ? void 0 : ref.name
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-in-area",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-page-top-career top-page-career images-tops-career",
                        style: {
                            backgroundImage: "url(" + (division === null || division === void 0 ? void 0 : (ref1 = division.divisionData) === null || ref1 === void 0 ? void 0 : ref1.img) + ")"
                        }
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var Detail_Hero = (Hero);

;// CONCATENATED MODULE: ./parts/career/Job/SecondHero/index.js
/* eslint-disable */ 



function SecondHero(param) {
    var breadcrump = param.breadcrump, _dataHeader = param.dataHeader, dataHeader = _dataHeader === void 0 ? {} : _dataHeader, career = param.career, language = param.language;
    var router = (0,next_router.useRouter)();
    var id = router.asPath.split("/");
    var ref = (0,react.useState)(""), breadcumbParentEn = ref[0], setBreadcumbParentEn = ref[1];
    var ref1 = (0,react.useState)(""), breadcumbParentId = ref1[0], setBreadcumbParentId = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        breadcrump === null || breadcrump === void 0 ? void 0 : (ref = breadcrump.HeaderMenus) === null || ref === void 0 ? void 0 : ref.forEach(function(item) {
            var ref;
            item === null || item === void 0 ? void 0 : (ref = item.child) === null || ref === void 0 ? void 0 : ref.forEach(function(secondItem) {
                // validate if parent 2 have url (page)
                if (((secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("id_url")) || (secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("en_url"))) && ("career" === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.id_url) || "career" === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.en_url))) {
                    setBreadcumbParentEn(item.en_menu_name);
                    setBreadcumbParentId(item.id_menu_name);
                }
            });
        });
    }, [
        dataHeader
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "top-page-detail",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-in-area",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        className: "breadcrumb",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: "Home"
                                })
                            }),
                            language === "EN" && breadcumbParentEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: breadcumbParentEn
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            language === "ID" && breadcumbParentId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: breadcumbParentId
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/career",
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: language === "EN" ? dataHeader.en_title : dataHeader.id_title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/career/detail/" + career.divisionId,
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: career.divisionName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: career.subDivisionName
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-in-area",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-page-top-career top-page-career",
                        style: {
                            backgroundImage: "url(" + career.divisionImg + ")"
                        }
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var Job_SecondHero = (SecondHero);

// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(7501);
;// CONCATENATED MODULE: ./parts/career/Job/Description/index.js
/* eslint-disable */ 


var Description = function(param) {
    var career = param.career, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-our-office-location",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: career === null || career === void 0 ? void 0 : career.position_name
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: language === "EN" ? "Job Description : " : "Deskripsi Pekerjaan : "
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-12",
                                children: [
                                    language === "EN" && (career === null || career === void 0 ? void 0 : career.en_desc) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            marginTop: "10px",
                                            marginBottom: "80px"
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: decodeURIComponent(escape((0,base64.decode)(career.en_desc)))
                                        }
                                    }),
                                    language === "ID" && (career === null || career === void 0 ? void 0 : career.id_desc) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            marginTop: "10px",
                                            marginBottom: "80px"
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: decodeURIComponent(escape((0,base64.decode)(career.id_desc)))
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Job_Description = (Description);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/@coreui/react/dist/index.es.js
var index_es = __webpack_require__(4475);
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__(6737);
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var react_redux_es = __webpack_require__(1894);
// EXTERNAL MODULE: ./services/index.js + 2 modules
var services = __webpack_require__(1671);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(4853);
// EXTERNAL MODULE: ./components/index.js + 23 modules
var components = __webpack_require__(9765);
;// CONCATENATED MODULE: ./utils/formatRp.js
var addCommas = function(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var addCommasDecimal = function(num) {
    return num.toLocaleString(undefined, {
        maximumFractionDigits: 2
    });
};
var removeNonNumeric = function(num) {
    return num.toString().replace(/[^0-9]/g, "");
};

;// CONCATENATED MODULE: ./parts/career/Job/ApplyJob/index.js
/* eslint-disable */ 











var ApplyJob = function(param) {
    var career = param.career, language = param.language, sexId = param.sexId, sexEn = param.sexEn, maritalStatusId = param.maritalStatusId, maritalStatusEn = param.maritalStatusEn, educationDegreeOption = param.educationDegreeOption, lastJobDurationId = param.lastJobDurationId, lastJobDurationEn = param.lastJobDurationEn;
    var history = (0,next_router.useRouter)();
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var inputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), CV = ref[0], setCV = ref[1];
    var ref1 = (0,react.useState)(""), nameFile = ref1[0], setNameFile = ref1[1];
    var ref2 = (0,react.useState)(null), recaptchaValue = ref2[0], setRecaptchaValue = ref2[1];
    // const [disabledGraduate, setDisabledGraduate] = useState(false);
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: {
            name: "",
            email: "",
            sex_id: [],
            marital_status_id: [],
            education_degree_id: [],
            last_job_duration_id: [],
            is_fresh_graduate: false,
            faculty_name: "",
            university_name: "",
            major_name: "",
            current_address: "",
            grade: "",
            company_name: "",
            city_name: "",
            expected_salary: "",
            last_position: "",
            statement: false,
            linkedin_url: "",
            portfolio_url: "",
            cv_file: ""
        }
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, _formState = ref3.formState, errors = _formState.errors, dirtyFields = _formState.dirtyFields, control = ref3.control, setValue = ref3.setValue;
    // CREATE
    var ref4 = (0,es.useMutation)(services/* FrontendAPI.sendJobApplication */.F.sendJobApplication, {
        onSuccess: function(res) {
            sweetalert_min_default()("Success", "", "success");
            inputRef.current.value = null;
            setNameFile("");
            setCV("");
            setValue("cv_file", "");
            setValue("name", "");
            setValue("email", "");
            setValue("education_degree_id", []);
            setValue("last_job_duration_id", []);
            setValue("marital_status_id", []);
            setValue("sex_id", []);
            setValue("expected_salary", "");
            setValue("is_fresh_graduate", "");
            setValue("faculty_name", "");
            setValue("university_name", "");
            setValue("major_name", "");
            setValue("current_address", "");
            setValue("grade", "");
            setValue("company_name", "");
            setValue("city_name", "");
            setValue("last_position", "");
            setValue("dob", "");
            setValue("birth_place", "");
            setValue("statement", false);
            setValue("linkedin_url", "");
            setValue("portfolio_url", "");
        // setDisabledGraduate(false);
        },
        onError: function(err) {
            (0,components/* ResponseError */.VL)(err, dispatch, history);
        }
    }), isLoadingSendJobApplication = ref4.isLoading, sendJobApplication = ref4.mutate;
    (0,react.useEffect)(function() {
        setValue("sex_id", []);
        setValue("marital_status_id", []);
        setValue("last_job_duration_id", []);
    }, [
        language
    ]);
    var onSubmit = function(data) {
        sweetalert_min_default()("Are you sure to send message?", {
            icon: "warning",
            dangerMode: true,
            buttons: {
                discard: {
                    text: "Cancel",
                    value: false
                },
                save: {
                    text: "Save",
                    value: true
                }
            }
        }).then(function(result) {
            if (result) {
                if (recaptchaValue) {
                    var formData = new FormData();
                    formData.append("name", data.name);
                    formData.append("email", data.email);
                    formData.append("position", career === null || career === void 0 ? void 0 : career.position_name);
                    formData.append("education_degree_id", data.education_degree_id.value);
                    formData.append("marital_status_id", data.marital_status_id.value);
                    formData.append("sex_id", data.sex_id.value);
                    formData.append("expected_salary", data.expected_salary.replace(/[, ]+/g, "").trim());
                    formData.append("is_fresh_graduate", data.is_fresh_graduate);
                    formData.append("faculty_name", data.faculty_name);
                    formData.append("university_name", data.university_name);
                    formData.append("major_name", data.major_name);
                    formData.append("current_address", data.current_address);
                    formData.append("grade", data.grade);
                    formData.append("dob", data.dob);
                    formData.append("birth_place", data.birth_place);
                    formData.append("cv_file", CV);
                    if (data.last_job_duration_id.value) {
                        formData.append("last_job_duration_id", data.last_job_duration_id.value);
                    }
                    if (data.last_position) {
                        formData.append("last_position", data.last_position);
                    }
                    if (data.company_name) {
                        formData.append("company_name", data.company_name);
                    }
                    if (data.city_name) {
                        formData.append("city_name", data.city_name);
                    }
                    if (data.linkedin_url) {
                        formData.append("linkedin_url", data.linkedin_url);
                    }
                    if (data.portfolio_url) {
                        formData.append("portfolio_url", data.portfolio_url);
                    }
                    sendJobApplication(formData);
                }
            }
        });
    };
    var handleChange = function(newValue, selectOption) {
        var action = selectOption.action, name = selectOption.name;
        if (action === "select-option") {
            setValue(name, newValue);
        } else if (action === "clear") {
            setValue(name, []);
        }
    };
    var handlechangeRecaptcha = function(value) {
        setRecaptchaValue(value);
    };
    var handleChangeSalary = function(e) {
        var data = parseInt(event.target.value.replace(/[, ]+/g, "").trim());
        setValue("expected_salary", addCommas(removeNonNumeric(data)));
    };
    // const changeStatus = () => {
    //   setDisabledGraduate(!disabledGraduate);
    //   setValue("last_job_duration_id", []);
    //   setValue("company_name", "");
    //   setValue("city_name", "");
    //   setValue("last_position", "");
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content mb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-our-office-location",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: language === "EN" ? "Apply This Position" : "Lamar Posisi Ini"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CForm */.lx, {
                                className: "form-contact-us",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                register: register,
                                                label: language === "EN" ? "Full Name" : "Nama Lengkap",
                                                name: "name",
                                                type: "text",
                                                errors: errors,
                                                isReqMsg: "Required"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                register: register,
                                                label: "Email",
                                                name: "email",
                                                type: "email",
                                                errors: errors,
                                                isReqMsg: "Required",
                                                patternMsg: "Email is not valid"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "Place of Birth" : "Tempat Lahir",
                                                    name: "birth_place",
                                                    type: "text",
                                                    errors: errors,
                                                    isReqMsg: "Required"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "Date of Birth" : "Tanggal Lahir",
                                                    name: "dob",
                                                    type: "date",
                                                    errors: errors,
                                                    isReqMsg: "Required"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    type: "select",
                                                    controller: index_esm/* Controller */.Qr,
                                                    control: control,
                                                    isClearable: true,
                                                    label: language === "EN" ? "Gender" : "Jenis Kelamin",
                                                    name: "sex_id.value",
                                                    handleSelect: handleChange,
                                                    register: register,
                                                    errors: errors,
                                                    isReqMsg: "Required",
                                                    nameParent: "sex_id",
                                                    dataSelect: language === "EN" ? sexEn : sexId
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    type: "select",
                                                    controller: index_esm/* Controller */.Qr,
                                                    control: control,
                                                    isClearable: true,
                                                    label: language === "EN" ? "Marital Status" : "Status Pernikahan",
                                                    name: "marital_status_id.value",
                                                    handleSelect: handleChange,
                                                    register: register,
                                                    errors: errors,
                                                    isReqMsg: "Required",
                                                    nameParent: "marital_status_id",
                                                    dataSelect: language === "EN" ? maritalStatusEn : maritalStatusId
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                register: register,
                                                label: language === "EN" ? "Current Address" : "Domisili Saat Ini",
                                                name: "current_address",
                                                type: "text",
                                                errors: errors,
                                                isReqMsg: "Required"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    type: "select",
                                                    controller: index_esm/* Controller */.Qr,
                                                    control: control,
                                                    isClearable: true,
                                                    label: language === "EN" ? "Last Education Degree" : "Tingkat Pendidikan Terakhir",
                                                    name: "education_degree_id.value",
                                                    handleSelect: handleChange,
                                                    register: register,
                                                    errors: errors,
                                                    isReqMsg: "Required",
                                                    nameParent: "education_degree_id",
                                                    dataSelect: educationDegreeOption
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "University" : "Universitas",
                                                    name: "university_name",
                                                    type: "text",
                                                    errors: errors,
                                                    isReqMsg: "Required"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "Faculty" : "Fakultas",
                                                    name: "faculty_name",
                                                    type: "text",
                                                    errors: errors,
                                                    isReqMsg: "Required"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "Major" : "Jurusan",
                                                    name: "major_name",
                                                    type: "text",
                                                    errors: errors,
                                                    isReqMsg: "Required"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                register: register,
                                                label: language === "EN" ? "Grade" : "IPK",
                                                name: "grade",
                                                type: "grade",
                                                errors: errors,
                                                isReqMsg: "Required"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: language === "EN" ? "Last Work Experience" : "Pengalaman Bekerja Terakhir"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Checkbox */.XZ, {
                                                register: register,
                                                label: "Fresh Graduate",
                                                name: "is_fresh_graduate",
                                                type: "checkbox",
                                                // onChange={changeStatus}
                                                errors: errors
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "Company Name" : "Nama Perusahaan",
                                                    name: "company_name",
                                                    type: "text",
                                                    errors: errors
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "City" : "Kota",
                                                    name: "city_name",
                                                    type: "text",
                                                    errors: errors
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    type: "select",
                                                    controller: index_esm/* Controller */.Qr,
                                                    control: control,
                                                    isClearable: true,
                                                    label: language === "EN" ? "Last Job Duration" : "Lama Bekerja Terakhir",
                                                    name: "last_job_duration_id.value",
                                                    handleSelect: handleChange,
                                                    register: register,
                                                    errors: errors,
                                                    nameParent: "last_job_duration_id",
                                                    dataSelect: language === "EN" ? lastJobDurationEn : lastJobDurationId
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: language === "EN" ? "Last Position" : "Posisi Terakhir",
                                                    name: "last_position",
                                                    type: "text",
                                                    errors: errors
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                register: register,
                                                label: language === "EN" ? "Expected Salary" : "Ekspetasi Gaji",
                                                name: "expected_salary",
                                                type: "salary",
                                                errors: errors,
                                                isReqMsg: "Required",
                                                handleChangeSalary: handleChangeSalary
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "Links"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CRow */.rb, {
                                        className: "mt-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: "Linkedin URL",
                                                    name: "linkedin_url",
                                                    type: "text",
                                                    errors: errors
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CostumInput */.j0, {
                                                    register: register,
                                                    label: "Portfolio URL",
                                                    name: "portfolio_url",
                                                    type: "text",
                                                    errors: errors
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* InputCV */.kM, {
                                                errors: errors,
                                                register: register,
                                                label: "Upload Resume",
                                                CV: CV,
                                                setCV: setCV,
                                                name: "cv_file",
                                                nameFile: nameFile,
                                                setNameFile: setNameFile,
                                                setValue: setValue,
                                                inputRef: inputRef
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("center", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Checkbox */.XZ, {
                                                    register: register,
                                                    label: language === "EN" ? "I declare that the information above is true" : "Saya menyatakan bahwa informasi diatas adalah benar",
                                                    name: "statement",
                                                    type: "checkbox",
                                                    isReqMsg: "Required",
                                                    errors: errors
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-2 align-items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("center", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                                    ref: function(e) {
                                                        var ref, ref1;
                                                        return setRecaptchaValue((e === null || e === void 0 ? void 0 : (ref = e.props) === null || ref === void 0 ? void 0 : ref.value) ? e === null || e === void 0 ? void 0 : (ref1 = e.props) === null || ref1 === void 0 ? void 0 : ref1.value : null);
                                                    },
                                                    name: "recaptcha",
                                                    value: recaptchaValue,
                                                    sitekey: "6LfDxzMiAAAAABYweb0eFCmROicEXyK9CFX6jVt6",
                                                    onChange: handlechangeRecaptcha
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("center", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CButton */.u5, {
                                                    onClick: handleSubmit(onSubmit),
                                                    disabled: recaptchaValue === null ? true : "",
                                                    style: {
                                                        width: "30%",
                                                        background: "#0d6efd",
                                                        boxShadow: "none"
                                                    },
                                                    loading: isLoadingSendJobApplication,
                                                    children: language === "EN" ? "Apply Now" : "Lamar Sekarang"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Job_ApplyJob = (ApplyJob);

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./parts/career/Detail/List/index.js
/* eslint-disable */ 





var List = function(param) {
    var search = param.search, setSearch = param.setSearch, division = param.division, language = param.language;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var id = router.asPath.split("/");
    var handleChange = function(e) {
        setSearch(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content contents-list-pages-careers",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-our-office-location",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CForm */.lx, {
                                className: "form_career_search",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormInput */.jO, {
                                    onChange: function(e) {
                                        return handleChange(e);
                                    },
                                    className: "form-input input_career_search",
                                    type: "text",
                                    placeholder: "Search By Position or Location"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                        className: "mt-4",
                        children: (division === null || division === void 0 ? void 0 : (ref = division.careerList) === null || ref === void 0 ? void 0 : ref.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("center", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: "Not Found"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: division === null || division === void 0 ? void 0 : (ref1 = division.careerList) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            style: {
                                                color: "#022e50",
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                letterSpacing: "0.42px",
                                                marginBottom: "15px !important"
                                            },
                                            children: item.name
                                        }),
                                        item === null || item === void 0 ? void 0 : (ref = item.Careers) === null || ref === void 0 ? void 0 : ref.map(function(secondItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                md: 6,
                                                style: {
                                                    marginBottom: "-15px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/career/job/" + secondItem.id,
                                                    locale: language === "ID" ? "id" : "en",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        style: {
                                                            color: "rgb(2, 46, 80)"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCard */.xH, {
                                                            style: {
                                                                cursor: "pointer"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CCardBody */.sl, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                                                                                children: secondItem.position_name
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CCol */.b7, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdLocationPin */.vcr, {
                                                                                    size: "14px"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CFormLabel */.L8, {
                                                                                    children: secondItem.location
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }, index)
                                                    })
                                                })
                                            }, index);
                                        })
                                    ]
                                });
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Detail_List = (List);

// EXTERNAL MODULE: ./utils/colors.js
var colors = __webpack_require__(3990);
;// CONCATENATED MODULE: ./parts/career/Items/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 





function Items(param) {
    var language = param.language, division = param.division;
    var ref;
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath.split("/").pop();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content contents-pages-career",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-our-office-location",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: language === "EN" ? "Job Vacancy" : "Lowongan Pekerjaan"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: division === null || division === void 0 ? void 0 : (ref = division.state) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "col-sm-6 col-md-3",
                                    children: (item === null || item === void 0 ? void 0 : item.position_count) === "0" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CCard */.xH, {
                                        className: "cards-for-careers",
                                        style: {
                                            // width: "350px",
                                            boxShadow: "0px 0px 15px ".concat(colors/* default.gray2 */.Z.gray2),
                                            marginBottom: "50px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardImage */.pX, {
                                                className: "image-blogs",
                                                height: "300",
                                                orientation: "top",
                                                src: item === null || item === void 0 ? void 0 : item.img
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardBody */.sl, {
                                                className: "card-body card-body-blogs",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("center", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardTitle */.tj, {
                                                            dangerouslySetInnerHTML: {
                                                                __html: item === null || item === void 0 ? void 0 : item.name
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardSubtitle */.a1, {
                                                            dangerouslySetInnerHTML: {
                                                                __html: (item === null || item === void 0 ? void 0 : item.position_count) ? (item === null || item === void 0 ? void 0 : item.position_count) + " Positions" : ""
                                                            },
                                                            className: "mb-2 text-medium-emphasis"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (item === null || item === void 0 ? void 0 : item.id) ? "/career/detail/" + (item === null || item === void 0 ? void 0 : item.id) : null,
                                        locale: language === "ID" ? "id" : "en",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CCard */.xH, {
                                                className: "cards-for-careers",
                                                style: {
                                                    // width: "350px",
                                                    boxShadow: "0px 0px 15px ".concat(colors/* default.gray2 */.Z.gray2),
                                                    marginBottom: "50px",
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardImage */.pX, {
                                                        className: "image-blogs",
                                                        height: "300",
                                                        orientation: "top",
                                                        src: item === null || item === void 0 ? void 0 : item.img
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardBody */.sl, {
                                                        className: "card-body card-body-blogs",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("center", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardTitle */.tj, {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: item === null || item === void 0 ? void 0 : item.name
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardSubtitle */.a1, {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: (item === null || item === void 0 ? void 0 : item.position_count) ? (item === null || item === void 0 ? void 0 : item.position_count) + " Positions" : ""
                                                                    },
                                                                    className: "mb-2 text-medium-emphasis"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }, index);
                            })
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var career_Items = (Items);

;// CONCATENATED MODULE: ./parts/career/index.js









/***/ })

}]);